import Resource from 'Resources/ResourceTyped';
import { SidebarCountFiltersBuilt, SidebarCountResult } from 'App/components/ListViewSidebar/Context/Helpers';

class ActivityList extends Resource<any> {
	constructor() {
		super('search/activitylist');

		this.dateFields = ['date', 'regDate', 'modDate'];
	}

	async getListViewCounts(filters: Array<SidebarCountFiltersBuilt>): Promise<Array<SidebarCountResult>> {
		return this._postRequest('listCounts', { filters }).then(({ data }) => {
			return data;
		});
	}
}

const resource = new ActivityList();

export default resource;
